import { firebaseAuth } from '../firebase';
import {
  INIT_AUTH,
  SIGN_IN_ERROR,
  SIGN_IN_SUCCESS,
  SIGN_OUT_SUCCESS,
  REQUEST_SIGN_IN,
} from './action-types';

export function initAuth(user) {
  return {
    type: INIT_AUTH,
    payload: user,
  };
}

export function signInError(error) {
  return {
    type: SIGN_IN_ERROR,
    payload: error,
  };
}

export function signInSuccess(result) {
  return {
    type: SIGN_IN_SUCCESS,
    payload: result.user || result,
  };
}

export function requestSignIn() {
  return {
    type: REQUEST_SIGN_IN,
  };
}

export function signInWithEmail(email, password) {
  return dispatch => {
    dispatch(requestSignIn());
    firebaseAuth
      .signInWithEmailAndPassword(email, password)
      .then(result => dispatch(signInSuccess(result)))
      .catch(error => dispatch(signInError(error)));
  };
}

export function signOutSuccess() {
  return {
    type: SIGN_OUT_SUCCESS,
  };
}

export function signOut() {
  return dispatch => {
    firebaseAuth.signOut().then(() => dispatch(signOutSuccess()));
  };
}



// WEBPACK FOOTER //
// ./src/core/auth/actions.js